
import { wrongSpotColor, wrongSpotColorBlind } from '@/assets/colors'
import { injectStrict } from '@/utils/Injection';
import { ColorBlindDataKey } from '@/utils/Injection';
import { defineComponent, PropType } from 'vue'

const __default__ = defineComponent({
    props: {
        letters: {
            required: true,
            type: Object as PropType<string[]>,
        }
    },
    setup() {
        const colorBlindData = injectStrict(ColorBlindDataKey);
        return { colorBlindData }
    },
    computed: {
        color() {
            return this.colorBlindData.isActive
                ? wrongSpotColorBlind
                : wrongSpotColor;
        }
    }
})

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "e189e418": (_ctx.color)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__